import * as React from 'react';
import axios from 'axios';
import { createUUID } from "../util/math";

export type ManageableForm = [FormData, React.Dispatch<FormAction>];

export type Filter = {
    id:string;
    title: string;
    active: boolean;
    age_group: Array<string>;
    educational_level: Array<string>;
    function: Array<string>
    extra_answer_id: Array<string>;
    gender: Array<string>;
    stage: Array<string>;
    location: Array<string>;
}

export type TimeSpan = {
    start_date: number;
    end_date: number;
}

export type FormData = {
    scan_id: string;
    id: string;
    filter: Array<Filter>;
    time_span: Array<TimeSpan>;
    stages: boolean;
    store: boolean;
    storing: boolean;
};

export type FilterOptionEntry = {
    title: string;
    value: string;
}

export type FilterQuestionOption = {
    title: string;
    id: string;
}

export type FilterQuestion = {
    title: string;
    option: Array<FilterQuestionOption>;
    id: string;
    question_type: string;
}

export type FilterOptions = {
    location: Array<FilterOptionEntry>;
    function: Array<FilterOptionEntry>;
    age_group: Array<FilterOptionEntry>;
    gender: Array<FilterOptionEntry>;
    educational_level: Array<FilterOptionEntry>;
    question: Array<FilterQuestion>;
}

export type FormAction = StoreAction | StoringAction | StoredAction;

export type StoreAction = {
    type: 'STORE';
    payload: {
        data: FormData;
    };
};

export type StoringAction = {
    type: 'STORING';
    payload: {};
};

export type StoredAction = {
    type: 'STORED';
    payload: {};
};

type PostData = {
    data: string;
};

export const FormContext: React.Context<ManageableForm> = React.createContext<ManageableForm>([
    {
        scan_id: '',
        id: '',
        filter: [],
        time_span: [],
        stages: false,
        store: false,
        storing: false,
    },
    (): void => undefined,
]);

export const FilterOptionsContext: React.Context<FilterOptions> = React.createContext<FilterOptions>({
    location: [],
    function: [],
    age_group: [],
    gender: [],
    educational_level: [],
    question: []
});

export const getEmptyFilter = (): Filter => {
    return {
        id: createUUID(),
        title: '',
        active: true,
        age_group: [],
        educational_level: [],
        function: [],
        extra_answer_id: [],
        gender: [],
        stage: [],
        location: []
    };
}

export const getEmptyTimeSpan = (): TimeSpan => {
    return {
        start_date: Math.round(new Date().getTime() / 1000),
        end_date: Math.round(new Date().getTime() / 1000)
    };
}

function formDataReducer(data: FormData, action: FormAction): FormData {
    switch (action.type) {
        case 'STORE':
            return {
                ...action.payload.data,
                store: true
            };
        case 'STORED':
            return {
                ...data,
                store: false,
                storing: false
            };
        case 'STORING':
            return {
                ...data,
                storing: true
            };
        default:
            return data;
    }
}

type FormProps = {
    children: React.ReactNode;
    data: FormData;
    filteroptions: FilterOptions;
    ajaxUrl: string;
};

function initialState(data: FormData): FormData {
    return {
        store: false,
        storing: false,
        stages: false,
        scan_id: data.scan_id,
        id: data.id,
        filter: data.filter,
        time_span: data.time_span
    };
}

export function FormProvider(props: FormProps): JSX.Element {
    const [data, dispatch] = React.useReducer(
        formDataReducer,
        initialState(props.data),
    );

    React.useEffect((): void => {
        const post: PostData = {
            data: JSON.stringify(data)
        };

        if (!data.storing) {

            if (data.store) {
                dispatch({type: 'STORING', payload: {}});

                axios
                    .post(
                        props.ajaxUrl + '?action=zmpzt_save_filter_set',
                        post,
                    )
                    .then((): void => {
                        dispatch({type: 'STORED', payload: {}});
                    });
            }

        }
    }, [data]);

    return (
        <FormContext.Provider value={[data, dispatch]}>
            <FilterOptionsContext.Provider value={props.filteroptions}>
                {props.children}
            </FilterOptionsContext.Provider>
        </FormContext.Provider>
    );
}
